import { CloseOutlined, ExpandAltOutlined, ShrinkOutlined } from '@ant-design/icons';
import { Waypoint } from '@omniafishing/core';
import classNames from 'classnames';
import React, { useState } from 'react';
import { MapRef } from 'react-map-gl';
import { useResponsive } from '../../../../hooks/use_responsive';
import { WaypointForm } from './waypoint_form';
import styles from './waypoint_form_screen.less';

interface WaypointFormScreenProps {
  discardModal: (waypoint?: Waypoint) => void;
  editableWaypoint: Waypoint | null;
  mapRef: MapRef;
  newWaypoint: Pick<Waypoint, 'lat' | 'lng' | 'waypoint_type' | 'name'> | null;
  onEditableWaypointChange: (waypoint: Waypoint | null, flyTo?: boolean) => void;
  onNewWaypointChange: (wp: Pick<Waypoint, 'lat' | 'lng' | 'waypoint_type' | 'name'>) => void;
  onSelectedWaypointChange: (waypoint: Waypoint | null) => void;
  selectedWaypoint: Waypoint | null;
}

export const WaypointFormScreen = (props: WaypointFormScreenProps) => {
  const {
    discardModal,
    editableWaypoint,
    mapRef,
    newWaypoint,
    onEditableWaypointChange,
    onNewWaypointChange,
    onSelectedWaypointChange,
    selectedWaypoint,
  } = props;

  const [mobileExpandedModal, setMobileExpandedModal] = useState(false);
  const { isMobile } = useResponsive();
  return (
    <div className={classNames(styles.modal, { [styles.modal__expanded]: mobileExpandedModal })}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <div>
            <span className={styles.heading}>{editableWaypoint ? 'Edit' : 'Save'} Waypoint</span>
            <span className="text-[12px] sm:text-[14px]">PRIVATE (only you can see this)</span>
          </div>
          <div className="flex items-baseline gap-2">
            {isMobile && (
              <span
                role="button"
                tabIndex={1}
                className={styles.expandModalIcon}
                onClick={() => setMobileExpandedModal(!mobileExpandedModal)}
              >
                {mobileExpandedModal ? <ShrinkOutlined /> : <ExpandAltOutlined />}
              </span>
            )}
            <span role="button" tabIndex={0} aria-label="Close">
              <CloseOutlined
                onClick={() => {
                  if (editableWaypoint) {
                    // if there is an editable waypoint discard and reset to selected waypoint
                    discardModal(selectedWaypoint);
                  } else {
                    discardModal();
                  }
                }}
              />
            </span>
          </div>
        </div>
        <WaypointForm
          editableWaypoint={editableWaypoint}
          mapRef={mapRef}
          newWaypoint={newWaypoint}
          onEditableWaypointChange={onEditableWaypointChange}
          onNewWaypointChange={onNewWaypointChange}
          onSelectedWaypointChange={onSelectedWaypointChange}
        />
      </div>
    </div>
  );
};
